<div class="info-page" dir="rtl">
  <div class="info-header">
    <h2>الشهادة البنكية</h2>

    <div class="share-section">
      <span>شارك المقال على</span>
      <div class="share-icons">
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
          <fa-icon [icon]="faTwitter"></fa-icon>
        </a>

        <a href="" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <fa-icon [icon]="faFacebook"></fa-icon>
        </a>
      </div>
    </div>
  </div>

  <p>
    "هي شهادة تصدر من أحد البنوك المرخص لها بتلقي الاكتتابات لشركات الأموال فقط تفيد إيداع النسبة المقررة من رأس المال حسب الشكل القانوني لها،
    حيث يتم إيداع 10 % على الأقل من رأس المال المصدر للشركات المساهمة والتوصية بالأسهم عند التأسيس يزيد إلى 25 % من رأس المال المصدر خلال ثلاثة أشهر من تاريخ قيد الشركة في السجل التجاري (وذلك كفائدة عامة)، كما يتم إيداع 100 % من أرصام الشركات ذات المسؤولية المحدودة"
  </p>
  <p>
    يمكنك تحميل نماذج طلبات استخراج الشهادة البنكية من خلال الروابط التالية:
  </p>
  <ul>
    <li><strong>تأسيس شركة ذات مسئولية محدودة</strong></li>
    <li>تأسيس شركة مساهمة مصرية</li>
  </ul>
</div>
